import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseLightRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.774 8.45A1.2 1.2 0 0 1 8.47 6.755l7.55 7.55 7.55-7.55a1.2 1.2 0 0 1 1.695 1.695L17.714 16l7.55 7.55a1.2 1.2 0 0 1-1.695 1.695l-7.55-7.55-7.55 7.55a1.2 1.2 0 0 1-1.695-1.695l7.55-7.55z" })
});
export default SvgCloseLightRegularIcon;
